import BenjaminHd from '@/domains/digitalAdvice/Experts/img/benjamin.hd.png';
import BenjaminMedium from '@/domains/digitalAdvice/Experts/img/benjamin.medium.png';
import BenjaminSmall from '@/domains/digitalAdvice/Experts/img/benjamin.small.png';
import ChloeHd from '@/domains/digitalAdvice/Experts/img/chloe.hd.png';
import ChloeMedium from '@/domains/digitalAdvice/Experts/img/chloe.medium.png';
import ChloeSmall from '@/domains/digitalAdvice/Experts/img/chloe.small.png';
import LucieHd from '@/domains/digitalAdvice/Experts/img/lucie.hd.png';
import LucieMedium from '@/domains/digitalAdvice/Experts/img/lucie.medium.png';
import LucieSmall from '@/domains/digitalAdvice/Experts/img/lucie.small.png';
import NicolasHd from '@/domains/digitalAdvice/Experts/img/nicolas.hd.png';
import NicolasMedium from '@/domains/digitalAdvice/Experts/img/nicolas.medium.png';
import NicolasSmall from '@/domains/digitalAdvice/Experts/img/nicolas.small.png';
import type { ExpertModel } from '@/domains/digitalAdvice/Experts/typings';

export enum Expert {
  BENJAMIN = 'benjamin',
  CHLOE = 'chloe',
  LUCIE = 'lucie',
  NICOLAS = 'nicolas',
}

export const EXPERTS: Record<Expert, ExpertModel> = {
  [Expert.BENJAMIN]: {
    expertCloseup: BenjaminSmall,
    expertGender: 'male',
    expertHDShot: BenjaminHd,
    expertMediumShot: BenjaminMedium,
    expertName: 'Benjamin',
  },
  [Expert.CHLOE]: {
    expertCloseup: ChloeSmall,
    expertGender: 'female',
    expertHDShot: ChloeHd,
    expertMediumShot: ChloeMedium,
    expertName: 'Chloé',
  },
  [Expert.LUCIE]: {
    expertCloseup: LucieSmall,
    expertGender: 'female',
    expertHDShot: LucieHd,
    expertMediumShot: LucieMedium,
    expertName: 'Lucie',
  },
  [Expert.NICOLAS]: {
    expertCloseup: NicolasSmall,
    expertGender: 'male',
    expertHDShot: NicolasHd,
    expertMediumShot: NicolasMedium,
    expertName: 'Nicolas',
  },
} as const;

export const expertList: Record<number, ExpertModel> =
  // prettier-ignore
  {
    1:    EXPERTS[Expert.CHLOE],
    116:  EXPERTS[Expert.CHLOE],
    173:  EXPERTS[Expert.CHLOE],
    205:  EXPERTS[Expert.LUCIE],
    323:  EXPERTS[Expert.CHLOE],
    463:  EXPERTS[Expert.BENJAMIN],
    585:  EXPERTS[Expert.BENJAMIN],
    673:  EXPERTS[Expert.LUCIE],
    796:  EXPERTS[Expert.LUCIE],
    823:  EXPERTS[Expert.NICOLAS],
    3943: EXPERTS[Expert.BENJAMIN],
    4203: EXPERTS[Expert.NICOLAS],
    4605: EXPERTS[Expert.CHLOE],
    4899: EXPERTS[Expert.CHLOE],
  } as const;
